var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertiesCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7256 13.5021L19.5498 8.6779C19.7788 8.44934 19.9076 8.1392 19.9079 7.81569C19.9082 7.49218 19.7799 7.18181 19.5514 6.95286C19.3228 6.7239 19.0127 6.59511 18.6892 6.59483C18.3657 6.59454 18.0553 6.72278 17.8263 6.95133L13.0021 11.7756L8.1779 6.95133C7.94894 6.72238 7.63841 6.59375 7.31461 6.59375C6.99082 6.59375 6.68029 6.72238 6.45133 6.95133C6.22238 7.18029 6.09375 7.49082 6.09375 7.81461C6.09375 8.13841 6.22238 8.44894 6.45133 8.6779L11.2756 13.5021L6.45133 18.3263C6.22238 18.5553 6.09375 18.8658 6.09375 19.1896C6.09375 19.5134 6.22238 19.8239 6.45133 20.0529C6.68029 20.2819 6.99082 20.4105 7.31461 20.4105C7.63841 20.4105 7.94894 20.2819 8.1779 20.0529L13.0021 15.2287L17.8263 20.0529C18.0553 20.2819 18.3658 20.4105 18.6896 20.4105C19.0134 20.4105 19.3239 20.2819 19.5529 20.0529C19.7819 19.8239 19.9105 19.5134 19.9105 19.1896C19.9105 18.8658 19.7819 18.5553 19.5529 18.3263L14.7256 13.5021Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertiesCloseIcon);
export default __webpack_public_path__ + "static/media/propertiesCloseIcon.e1ef995b8ccb13c24c9b93bb84f13775.svg";
export { ForwardRef as ReactComponent };